import { gql } from '@apollo/client'

export const FORWARD_TO_RIGHTMART = gql`
  mutation forwardToRightmart($id: ID!, $attributes: ForwardToRightmartInput!) {
    forwardToRightmart(id: $id, attributes: $attributes)
  }
`
